import React from "react";
import "./Footer.css";
import { FaPhoneAlt, FaCalendarAlt } from "react-icons/fa"; // ✅ Import icons

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-content container d-flex flex-column flex-md-row justify-content-between align-items-center">
        
        {/* Left side - Brand / Info */}
        <div className="footer-info text-center text-md-start mb-3 mb-md-0">
          <h5 className="footer-brand">The Gifted Child</h5>
          <p className="footer-text">Pediatric Therapy Centre</p>
        </div>

        {/* Right side - Actions */}
        <div className="footer-actions d-flex gap-3">
          <a href="tel:+91 9071147506" className="btn btn-outline-primary">
            <FaPhoneAlt className="me-2" /> Contact Us
          </a>
          <a href="/contact" className="btn btn-primary">
            <FaCalendarAlt className="me-2" /> Book an Appointment
          </a>
        </div>
      </div>

      {/* Bottom note */}
      <div className="footer-bottom text-center mt-3">
        <p className="mb-0">
          © {new Date().getFullYear()} The Gifted Child. All Rights Reserved.
        </p>
      </div>
    </footer>
  );
}
